import { useCallback, useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import type { PublicUser } from "../../shared/types";
import { ConsumerHeader } from "../components/ConsumerHeader";
import { api } from "../lib/api";
import type { ConsumerBootstrap } from "../lib/models";
import { ConsumerHome } from "./ConsumerHome";
import { FitBuilderPage } from "./FitBuilderPage";
import { GarmentsPage } from "./GarmentsPage";
import { MyFitPage } from "./MyFitPage";
import { PreferencesPage } from "./PreferencesPage";
import { ScanPage } from "./ScanPage";
import { FitPassPage } from "./FitPassPage";
import { StylePage } from "./StylePage";
import { ConsumerBottomNav } from "../components/ConsumerBottomNav";

export function ConsumerApp({ user, onLogout }: { user: PublicUser; onLogout: () => void }) {
  const [data, setData] = useState<ConsumerBootstrap | null>(null);
  const [error, setError] = useState("");
  const location = useLocation();
  const refresh = useCallback(async () => { const result = await api<ConsumerBootstrap>("/bootstrap"); setData(result); setError(""); }, []);
  useEffect(() => { void refresh().catch(() => setError("Non riusciamo a caricare le tue taglie.")); }, [refresh]);
  useEffect(() => { window.scrollTo(0,0); }, [location.pathname]);
  if (error) return <div className="fatal-state"><h1>Le tue taglie non sono disponibili.</h1><p>{error}</p><button onClick={() => window.location.reload()}>Riprova</button></div>;
  if (!data) return <div className="splash"><span>Prepariamo la tua taglia…</span></div>;
  return <div className="consumer-app experience">
    {location.pathname !== "/app/pass" ? <ConsumerHeader user={user} onLogout={onLogout} /> : null}
    <Routes>
      <Route index element={<ConsumerHome data={data} onComplete={refresh} />} />
      <Route path="scan" element={<ScanPage data={data} onComplete={refresh} />} />
      <Route path="shop" element={<Navigate to="/demo/tshirt" replace />} />
      <Route path="style" element={<StylePage data={data} onComplete={refresh} />} />
      <Route path="pass" element={<FitPassPage data={data} />} />
      <Route path="fit/:productId" element={<FitBuilderPage key={location.pathname + location.search} data={data} onComplete={refresh} />} />
      <Route path="my-fit" element={<MyFitPage data={data} />} />
      <Route path="preferences" element={<PreferencesPage data={data} onComplete={refresh} />} />
      <Route path="garments" element={<GarmentsPage data={data} />} />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
    {["/app","/app/style","/app/my-fit"].includes(location.pathname) ? <ConsumerBottomNav/> : null}
  </div>;
}
